// Keep native summary keyboard behavior and animate the measured height in both
// directions. Closing must leave `open` set until the content has slid away.
const instances = new WeakMap()

export default {
  mounted(element) {
    const summary = element.querySelector(":scope > summary")
    if (!summary) return

    const motion = window.matchMedia("(prefers-reduced-motion: reduce)")
    let animation = null
    let targetOpen = element.open

    const cancelAnimation = () => {
      if (!animation) return
      animation.onfinish = null
      animation.cancel()
      animation = null
    }
    const settle = () => {
      cancelAnimation()
      element.open = targetOpen
    }
    const onClick = event => {
      // A link or other control inside a summary keeps its own interaction.
      if (event.defaultPrevented || event.target.closest("a, button, input, select, textarea")) return
      if (motion.matches || typeof element.animate !== "function") return

      event.preventDefault()
      const startHeight = element.getBoundingClientRect().height
      targetOpen = animation ? !targetOpen : !element.open
      cancelAnimation()

      // Measure both native layouts, including padding, borders and max-height.
      // These synchronous changes happen before paint, without a visual flash.
      element.open = targetOpen
      const endHeight = element.getBoundingClientRect().height
      element.open = true
      animation = element.animate([
        { height: `${startHeight}px`, overflow: "hidden", boxSizing: "border-box" },
        { height: `${endHeight}px`, overflow: "hidden", boxSizing: "border-box" }
      ], { duration: 280, easing: "cubic-bezier(.22, 1, .36, 1)", fill: "both" })
      animation.onfinish = settle
    }
    const onMotionChange = () => { if (motion.matches && animation) settle() }
    const onResize = () => { if (animation) settle() }

    summary.addEventListener("click", onClick)
    motion.addEventListener("change", onMotionChange)
    window.addEventListener("resize", onResize)
    instances.set(element, () => {
      cancelAnimation()
      summary.removeEventListener("click", onClick)
      motion.removeEventListener("change", onMotionChange)
      window.removeEventListener("resize", onResize)
    })
  },
  beforeUnmount(element) {
    instances.get(element)?.()
    instances.delete(element)
  }
}
